import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
};

export const GetGVPCountDashboard = async (
    StartDate,
    endDate,
    ZoneId,
    CircleId,
    ShiftId
) => {
    try {
        let apiUrl =
            API_BASE_URL1 +
            "DashboardReport/GVPCountDashboard?";

        // Append StartDate and endDate
        if (StartDate && endDate) {
            apiUrl += `startDate=${StartDate}&endDate=${endDate}`;
        }

        // Append ZoneId if not null
        if (ZoneId !== null) {
            apiUrl += `&ZoneId=${ZoneId}`;
        }

        // Append CircleId if not null
        if (CircleId !== null) {
            apiUrl += `&CircleId=${CircleId}`;
        }

        // Append ShiftId if not null
        if (ShiftId !== null) {
            apiUrl += `&ShiftId=${ShiftId}`;
        }

        const token = getToken(); // Get the token
        const response = await axiosInstance.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};
